interface Props {
	iconColor?: string;
	width?: string;
	height?: string;
}
const DoubleArrowNext = ({ iconColor = '#868E96', width = '24', height = '24' }: Props) => (
	<svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path d="M7 5L13.1515 11.1515C13.6201 11.6201 13.6201 12.3799 13.1515 12.8485L7 19" stroke={iconColor} strokeWidth="1.5" strokeLinecap="round" />
		<path d="M11 5L17.1515 11.1515C17.6201 11.6201 17.6201 12.3799 17.1515 12.8485L11 19" stroke={iconColor} strokeWidth="1.5" strokeLinecap="round" />
	</svg>
);

export default DoubleArrowNext;
